module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/301.515c2368.png";